import { useMemo } from 'react';
import { GlCodeFormatType } from 'src/services/useGetGlMasks';

export interface GlCodeFormatErrors {
  format: string[];
}

const defaultGlCodeFormatError: GlCodeFormatErrors = {
  format: [],
};

export interface GlCodeFormatWarnings {
  format: string[];
}
const defaultGlCodeFormatWarning: GlCodeFormatWarnings = {
  format: [],
};

export const useGLCodeFormatErrors = (
  glCodeFormats: GlCodeFormatType[],
  initialGlCodeFormats: GlCodeFormatType[]
) => {
  const errors = useMemo(() => {
    const formatCounts: Record<string, number> = {};
    const allowedSpecialCharacters = '@*#\\-._() ';
    const allowedCharactersRegex = new RegExp(`^[a-zA-Z0-9${allowedSpecialCharacters}]*$`);
    glCodeFormats?.forEach((format) => {
      const text = format.format.trim().toUpperCase();
      formatCounts[text] = (formatCounts[text] || 0) + 1;
    });

    return (
      glCodeFormats?.map((glCodeFormat) => {
        let error: GlCodeFormatErrors = { ...defaultGlCodeFormatError };

        if (!glCodeFormat.format?.trim()) {
          error.format = ['Format field must not be empty'];
        } else if (glCodeFormat.format.length > 75) {
          error.format = ['Format must not exceed 75 characters'];
        } else if (!allowedCharactersRegex.test(glCodeFormat.format)) {
          error.format = ['Format contains invalid characters'];
        }

        if (
          glCodeFormat.format.trim() &&
          formatCounts[glCodeFormat.format.trim().toUpperCase()] > 1
        ) {
          error.format = ['Duplicate format is not allowed'];
        }
        return error;
      }) || []
    );
  }, [glCodeFormats]);

  const warnings = useMemo(
    () =>
      glCodeFormats?.map((glCodeFormat) => {
        let warning: GlCodeFormatWarnings = { ...defaultGlCodeFormatWarning };

        const originalGLCodeFormat = initialGlCodeFormats.find(
          (item) => item.rowId === glCodeFormat.rowId
        );
        if (glCodeFormat.isNewFormat) {
          warning.format = ['Newly added Format'];
        } else if (glCodeFormat?.format !== originalGLCodeFormat?.format) {
          warning.format = ['Format has unsaved changes'];
        }
        return warning;
      }),
    [glCodeFormats, initialGlCodeFormats]
  );

  return { errors, warnings };
};
